import React, { useState, useRef, useCallback } from "react";
import styles from "./LandingPage.module.scss";
import Title from "../Non-humans title gif/Title.gif";
import { Link } from "@reach/router";
import DateCountdown from "react-date-countdown-timer";
import DatabaseToggle from "./DatabaseToggle";

function LandingPage() {
  const [alpha, setWhetherAlpha] = React.useState("markers3");

  const toggleAlpha = () => {
    if (alpha === "markers3") {
      setWhetherAlpha("markers2");
    } else {
      setWhetherAlpha("markers3");
    }
  };

  return (
    <div className={styles.background}>
      <div className={styles.flexContainer}>
        <div className={styles.content}>
          <img
            className={styles.title}
            src={Title}
            alt="non-humans of Liverpool"
          />
          <br />
          <Link to={"/home/" + alpha + "/"}>
            <button className={styles.startbutton}>START</button>
          </Link>
          <br />
          <br />
          <br />
          <br />
          <Link className={styles.linkButton} to={"/about/" + alpha + "/"}>
            ABOUT THE PROJECT
          </Link>
          <br />
          <br />

          <Link className={styles.linkButton} to={"/credits/" + alpha + "/"}>
            VIEW CREDITS
          </Link>
          <br />
          <br />
        </div>
      </div>
      <aside>
        <p>
          The final tournament for this game took place on March the First 2021,
          the site is now a record of the thoughts, problems, ideas and hopes of
          non-human folk put forward before that time.
        </p>
        <p>
          To view data and markers from the Alpha testing period in Autumn of
          2020, click the red switch below before entering.
        </p>
        <DatabaseToggle alpha={alpha} toggleAlpha={toggleAlpha} />
      </aside>
    </div>
  );
}

export default LandingPage;
